module.exports = __webpack_public_path__ + "img/445.4e541963.png";